<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <wiz-hgroup width="350px" height="100%">
    <multi-display #mdMain width="100%" height="100%" [config]="mainConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <!-- <wiz-icon #btnRemove [wizDisabled]="!mayDelete()" (wizClick)="askForDelete()" class="image-purple"
          [wizTooltip]="'$.common.delete.$'" (click)="askForDelete()">delete</wiz-icon> -->
      </wiz-hgroup>

      <wiz-hgroup target="title" [verticalAlign]="'center'" class="add-btn" gap="10" padding="0 0 10px">
        <!-- <wiz-icon #btnCreate [wizTooltip]="'$.matrix.add.$'" tooltipPlacement="right" class="image-back-orange"
          (click)="askForAdd()" [wizDisabled]="cantCreate">add</wiz-icon> -->
        <wiz-label class="titleLabel" [wizLabel]="'$.matrix.title.$'" [wizTextBehavior]="'truncate'"
          width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-hgroup>

  <!-- zone détail "vraie" -->
  <wiz-vgroup class="section-container-parent" #vgEdition wizValidationContainer width="100%" minWidth="600px"
    height="100%" gap="10" [visible]="false">
    <!-- entête d'édition -->
    <wiz-hgroup wizValidationContainer width="100%" class="section-container" padding="10px" gap="10" [wizDisabled]="true">
      <wiz-text-input #tiCode
        [wizLabel]="'$.common.code.$'" width="160px"
        >
      </wiz-text-input>

      <wiz-text-input #tiVersion [wizLabel]="'$.common.version.$'" width="160px">
      </wiz-text-input>

      <wiz-text-input #tiRowCount [wizLabel]="'$.matrix.rowcount.$'" width="160px">
      </wiz-text-input>

    </wiz-hgroup>

    <!-- détail d'édition -->
    <wiz-vgroup wizValidationContainer width="100%" minWidth="300px" height="100%" class="section-container"
      padding="10px" gap="10" style="overflow-x: auto"> 
    
    <wiz-hgroup width="100%" height="140px" style="overflow-x: auto">
      <wiz-text-area #taQuery [wizLabel]="'$.cnx.step.reader.query.$'" height="100%" width="100%" style="font-size: 14px !important;"></wiz-text-area>
      <wiz-vgroup width="120px">
        <wiz-numeric-input #niField
          width="100%"
          wizMinNumber="0"
          wizMaxNumber="30"
          nbDecimal="0"
          [wizLabel]="'$.pivot.mass.edit.value.$'"
        ></wiz-numeric-input>
        <wiz-label #resultLbl width="100%"></wiz-label>
      </wiz-vgroup>


      <wiz-vgroup width="150px">
        <wiz-button
          #btnSave
          (click)="run()"
          [wizLabel]="'$.cnx.step.reader.query.$'"
          [wizIcon]="'icon-arrow-right'"
          [iconPlacement]="'right'"
          width="150px"
        ></wiz-button>
        <wiz-button
          #btnCancel
          (click)="unrun()"
          class="cancel-button"
          [wizIcon]="'icon-arrow-left'"
          [wizLabel]="'$.common.cancel.$'"
          width="100px"
        ></wiz-button>
      </wiz-vgroup>
    </wiz-hgroup>

    <wiz-ag-grid #agGrid
      width="100%"
      height="100%"
      [wizDatasource]="matrixDS"
      [columnDefs]="columns"
      [gridOptions]="gridOptions"
    ></wiz-ag-grid>
    



    </wiz-vgroup>
  </wiz-vgroup>
</wiz-h-divider>